import app_img from '@/public/article/App.webp';
import invoicing from '@/public/article/Invoice.webp';
import article1 from '@/public/article/picture.webp';
import time_img from '@/public/industries/painting/Accurate Time Tracking.png';
import main_bg from '@/public/industries/painting/main.webp';
import schedule_img from '@/public/industries/painting/Optimize Your Work Order Process.webp';
import managment_img from '@/public/industries/painting/Proactive Notifications.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does My Painting Business Need Software?',
    text: 'Yes, your painting business can greatly benefit from specialized software. It helps streamline critical operations such as job scheduling, client management, and invoicing. Implementing software can lead to better project management, enhanced customer satisfaction, and overall operational efficiency, making it crucial for any painting business aiming for growth and improved service delivery.',
  },
  {
    title: 'Is Orcatec Painting Software Free?',
    text: `Orcatec offers a free starter package that allows businesses to explore the features without any initial investment. This package is perfect for small businesses or those using digital solutions. For additional functionality, users can choose from flexible paid options that fit their specific needs and budget.`,
  },
  {
    title: 'Does Orcatec Have an App for Painting Contractors?',
    text: `Indeed, Orcatec provides a comprehensive mobile app suitable for iOS and Android devices. This app enables painting contractors to manage their operations on the go, including scheduling jobs, communicating with clients, and monitoring project progress. It's designed to support the dynamic and mobile nature of the painting industry.`,
  },
  {
    title: 'What is a Painting Estimate App?',
    text: `A painting estimate app is a tool that helps contractors quickly generate accurate job quotes. It calculates the materials and labor costs required for each project, ensuring that quotes are competitive yet profitable. These applications have provisions for customization in order to meet your business needs and pricing strategies.`,
  },
  {
    title: 'What is Painting Management Software?',
    text: `Painting management software is a comprehensive tool to manage painting works. This means that the software will assist in job scheduling, the management of staff, billing, and inventory control. This business center becomes the main platform to manage all your business operations in a way that each and every process, right from the initiation of the project to its completion, should be managed in the most efficient and effective manner.`,
  },
];

const testimonals = [
  {
    text: `Being a small business owner, cost-consciousness is always on the mind. The free starter package by Orcatec allowed us to test the waters with no investment on our part. The flexibility to choose which features we pay for as we grow has made all the difference.`,
    name: 'Tom L., ',
    position: 'Owner of TLC Painting Services',
  },

  {
    text: `I was initially skeptical about moving to a digital platform, but Orcatec's easy customization and the mobile app have completely won me over. Being able to manage everything from my phone, no matter where I am, has not only saved time but also significantly reduced our paperwork.`,
    name: 'Karen S., ',
    position: 'Operations Manager',
  },
  {
    text: `Orcatec has transformed the way we handle our projects from start to finish. The job management tools are incredibly intuitive, making scheduling and tracking our tasks a breeze. We've seen a noticeable improvement in our project timelines and client satisfaction."`,
    name: 'Jessica M., ',
    position: 'SpectrumWorks Painting',
  },

  {
    text: `Being a small business owner, cost-consciousness is always on the mind. The free starter package by Orcatec allowed us to test the waters with no investment on our part. The flexibility to choose which features we pay for as we grow has made all the difference.`,
    name: 'Tom L., ',
    position: 'Owner of TLC Painting Services',
  },

  {
    text: `I was initially skeptical about moving to a digital platform, but Orcatec's easy customization and the mobile app have completely won me over. Being able to manage everything from my phone, no matter where I am, has not only saved time but also significantly reduced our paperwork.`,
    name: 'Karen S., ',
    position: 'Operations Manager',
  },
  {
    text: `Orcatec has transformed the way we handle our projects from start to finish. The job management tools are incredibly intuitive, making scheduling and tracking our tasks a breeze. We've seen a noticeable improvement in our project timelines and client satisfaction."`,
    name: 'Jessica M., ',
    position: 'SpectrumWorks Painting',
  },
];

const industries = {
  title: 'Our Top Industries',
  description: `Our industries section provides an in-depth look at how different businesses, from residential to commercial painting contractors, can leverage our painting company software for optimal efficiency. Discover each industry's unique challenges and solutions, ensuring your painting business thrives regardless of the segment.
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Painting Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Streamlined Work Order Management',
      },
      href: '#',
      tag: 'Work Order Management',
      title: 'Streamlined Work Order Management',
      text: `Manage all your work orders easily and supervise them from one place. Orcatec's painting business management software allows you to easily create, track, assign, and schedule all your digital work orders. This functionality ensures optimal resource allocation and helps avoid scheduling conflicts.`,
      list: [
        {
          text: 'Quickly generate work orders with all the necessary details.',
        },
        {
          text: 'Monitor progress and assign tasks to specific team members.',
        },
        {
          text: 'Plan work orders according to availability and project timelines.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: time_img,
        alt: ' Job Management',
      },
      href: '#',
      tag: 'Job Management',
      title: 'Enhanced Job Management',
      text: `Keep a tight grip on every aspect of your painting projects. Orcatec's software for painting business allows you to track the time spent on each job, manage materials, and upload necessary attachments for a comprehensive job management approach. This feature helps in maintaining accountability and streamlining project execution.`,

      list: [
        { text: 'Monitor how much time is spent on each appointment or job.' },
        { text: 'Keep an inventory of the materials used for each job.' },
        {
          text: 'Attach photos, documents, or notes relevant to each project.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer Relationships Management',
      },
      href: '#',
      tag: ' Notifications System',
      title: 'Effective Notifications System',
      text: `Stay connected and informed with automated notifications. Orcatec’s software sends timely reminders, follow-ups, and updates to keep everyone on the same page. This feature enhances communication between staff and clients, ensuring smooth project flows and enhanced client satisfaction.`,
      list: [
        {
          text: 'Set up alerts for upcoming tasks and deadlines.',
        },
        {
          text: 'Automatically send follow-up messages to clients.',
        },
        {
          text: 'Notify team members and clients of important changes or progress.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Invoicing and Billing ',
      },
      href: '#',
      tag: 'Invoicing and payments',
      title: 'Simplified Invoicing',
      text: `Simplify your billing with Orcatec's easy invoicing feature. Create electronic invoices directly in the system and send them through email or text to your client. Save on the paperwork in your office and expedite the payment process of your billings while improving accuracy with this function.`,

      list: [
        {
          text: 'Create detailed invoices in just a few clicks.',
        },
        {
          text: 'Deliver invoices via email or text for faster processing.',
        },
        {
          text: 'Automatically store and manage all invoice data for easy access and reference.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Painting Contractor Software',
  title: {
    first_part: 'Transform Your Painting business with',
    second_part: 'Orcatec',
  },
  description: `Make Your Projects Flow Better with the Top Free Painting Contractor Software
  Get rid of the boring burden of work in order to unlock the power of being efficient with our top-rated, free painting contractor software. `,
  info: [
    { title: '40%', description: 'Increase in Projects Completed On Schedule' },
    {
      title: '25%',
      description: 'Improvement in Customer Satisfaction Ratings',
    },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is Painting Business Software?',
  },
  title: 'What is Painting Business Software?',
  description: `Painting business software is meant to serve the painting contractor by aiding in managing his painting company operations in a much better way. They help painting companies by providing software that supports job scheduling, client management, invoicing, and other important parts specific to the business needs of a painting company. Orcatec offers a full software solution for the painting industry, which effectively streamlines day-to-day operations and resolves typical challenges that subcontractors, businesses, and painting contractors face. `,
  item: [
    {
      title: 'Job Scheduling and Management',
      description: `Orcatec's software allows painting businesses to efficiently schedule jobs, track project progress, and manage deadlines. `,
    },
    {
      title: 'Client Management',
      description:
        'The software includes tools for managing client information, maintaining communication histories, and tracking ongoing projects. ',
    },
    {
      title: 'Invoicing and Financial Tracking',
      description: `Orcatec’s software automates the invoicing process and tracks all financial transactions.`,
    },
    {
      title: 'Supply Management',
      description:
        'The system also includes inventory management features that help businesses track paint supplies and other materials. ',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Painting Contractors Software Choose Orcatec?',
  },
  title: 'Why Painting Contractors Software Choose Orcatec?',
  description: `Painting contractors' software is created by contractors and for contractors, designed specifically for the painting industry, and comes with features that streamline operations. The starter package is free of cost with an ability to get additional paid options, flexible, and cost-effective according to business requirements. The software's multi-device compatibility ensures accessibility and convenience, enhancing productivity:`,
  item: [
    {
      title: '',
      description:
        'Orcatec provides a free starter package that allows painting contractors to try out the software without any financial commitment. ',
    },
    {
      title: '',
      description:
        'The software for painters offers flexibility in choosing paid features, allowing users to customize their packages according to their business requirements and budget constraints.',
    },
    {
      title: '',
      description: `You can customize workflows, add custom fields, or set specific alerts to make Orcatec suit your business operations. `,
    },
    {
      title: '',
      description: `Orcatec is accessible using PCs, tablets, mobile phones, and iOS, and Android operating systems. But ease of use does not take a back seat to functionality. `,
    },

    {
      title: '',
      description: `Despite its powerful functionality, Orcatec was designed with a user-friendly interface – easy for all your employees to navigate and implement, saving you valuable time and allowing your staff to become productive quickly.
      `,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Here in this section, we dwell on advanced ways to enhance your business operations and bring insights from the finest experts in the industry. Therefore, stay with us because our regular, updated practical advice will be translated into action tailor-made for painting contractors.`,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Let us guide you to experience in appliance repair management software! Orcatec team is here to help you. Our experts are ready to amplify your operational efficiency.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
